module.exports = __webpack_public_path__ + "static/media/3DPPA1.753f3ce9.jpg";